export default "__VITE_ASSET__979d5067__"